import { configureStore } from "@reduxjs/toolkit";
import srciInputDataReducer  from "./reducers/SrciInputData";
import applepayInputDataReducer from "./reducers/ApplePayInputData";
import googlepayInputDataReducer from "./reducers/GooglePayInputData";

const localStorageKey = "SRCiStore"

export const saveToLocalStorage = (state: any) => {
  try {
    localStorage.setItem(localStorageKey, JSON.stringify(state));
  } catch (e) {
    console.error(e);
  }
};

const loadFromLocalStorage = () => {
  try {
    const stateStr = localStorage.getItem(localStorageKey);
    return stateStr ? JSON.parse(stateStr) : undefined
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const clearLocalStorage = () => {
  try {
    localStorage.removeItem(localStorageKey)
  } catch (e) {
    console.error(e)
  }
}

export const getArrayFromEnum = (object: Object) => {
  return Object.values(object).map((item) => {
    return {
      key: item,
      text: item,
      value: item
    }
  })
}

const reducers = {
  srciInputData: srciInputDataReducer,
  applepayInputData: applepayInputDataReducer,
  googlepayInputData: googlepayInputDataReducer
}

const store = configureStore({
  reducer: reducers,
  preloadedState: loadFromLocalStorage()
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store